import {
    BaseScoreResult,
    QuestionnaireResponse,
    Item,
    findItemByLinkId,
    getAnswerCode
} from './types';

const SCORE_EXTENSION_URL = "http://hl7.org/fhir/StructureDefinition/questionnaire-optionScore";

export type LawtonDependence =
    | 'independente'
    | 'parcial'
    | 'total';

export interface LawtonScoreResult extends BaseScoreResult {
    totalScore: number;
    dependence: LawtonDependence;
    details: Record<string, number>;
}

const LAWTON_CODE_SCORE: Record<string, number> = {
    '1': 3,
    '2': 1,
    '3': 2
};

function getItemScoreFromOption(item: Item | undefined): number {
    if (!item) return 0;
    const code = getAnswerCode(item);
    if (code === undefined) return 0;

    const selectedOption = item.answerOption?.find(opt => opt.valueCoding?.code === code);
    const scoreExtension = selectedOption?.extension?.find(ext => ext.url === SCORE_EXTENSION_URL);

    if (scoreExtension?.valueInteger !== undefined && Number.isFinite(scoreExtension.valueInteger)) {
        return scoreExtension.valueInteger;
    }
    return LAWTON_CODE_SCORE[code] ?? 0;
}

export function getLawtonDependence(totalScore: number): LawtonDependence {
    if (totalScore >= 27) return 'independente';
    if (totalScore >= 18) return 'parcial';
    return 'total';
}

const LAWTON_ITEM_LINK_IDS = [
    'lawton_1',
    'lawton_2',
    'lawton_3',
    'lawton_4',
    'lawton_5',
    'lawton_6',
    'lawton_7',
    'lawton_8',
    'lawton_9'
] as const;

export function processLawtonQuestionnaire(response: QuestionnaireResponse): LawtonScoreResult {
    const rootItems = response.item || [];

    const details: Record<string, number> = {};
    let totalScore = 0;

    LAWTON_ITEM_LINK_IDS.forEach(linkId => {
        const item = findItemByLinkId(rootItems, linkId);
        const score = getItemScoreFromOption(item);
        details[linkId] = score;
        totalScore += score;
    });

    const dependence = getLawtonDependence(totalScore);

    return {
        questionnaireId: response.questionnaire?.split('/')?.[1],
        questionnaireResponseId: response.id,
        totalScore,
        dependence,
        details
    };
}
